import { createTheme } from '@mui/material';
import '@fontsource/jost/300.css';
import '@fontsource/jost/400.css';
import '@fontsource/jost/500.css';
import '@fontsource/jost/700.css';
import '@fontsource/jost/900.css';

const defaultTheme = createTheme();

export const uxBeautyTheme = createTheme({
  palette: {
    primary: {
      main: '#212529',
      light: '#6C757D'
    },
    secondary: {
      main: '#E388C5',
      light: '#F1EAF4'
    }
  },
  typography: {
    allVariants: {
      color: '#212529'
    },

    fontFamily: 'Jost',
    h1: {
      fontSize: 48,
      lineHeight: '120%',
      fontWeight: '700',
      letterSpacing: 0
    },
    h2: {
      fontSize: 32,
      letterSpacing: 0.25,
      lineHeight: '130%',
      fontWeight: '700'
    },
    h3: {
      fontSize: 24,
      lineHeight: '131%',
      fontWeight: '500',
      letterSpacing: 0
    },
    h4: {
      fontSize: 20,
      letterSpacing: 0.15,
      lineHeight: '140%',
      fontWeight: '500'
    },
    h5: {
      fontSize: 16,
      letterSpacing: 0.15,
      lineHeight: '125%',
      fontWeight: '500'
    },
    body1: {
      fontSize: 16,
      letterSpacing: 0.15,
      lineHeight: '125%',
      fontWeight: '400'
    },
    body2: {
      fontSize: 14,
      letterSpacing: 0.17,
      lineHeight: '140%',
      fontWeight: '400'
    },
    caption: {
      fontSize: 12,
      letterSpacing: 0.04,
      lineHeight: '130%',
      fontWeight: '400'
    }
  },
  components: {
    MuiAlert: {
      defaultProps: {
        square: false
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          textTransform: 'none'
        },

        outlined: ({ theme }) => ({
          border: 'none',
          boxShadow: theme.shadows[1],
          background: 'white',
          '&:hover': {
            border: 'none'
          },

          '&&.active': {
            background: theme.palette.secondary.light,
            color: theme.palette.primary.main
          },
          '&.Mui-disabled': {
            background: theme.palette.grey[300],
            boxShadow: 'none',
            border: 'none'
          }
        }),
        contained: ({ theme }) => ({
          '&&.active': {
            background: theme.palette.secondary.light,
            color: theme.palette.primary.main
          }
        }),
        text: ({ theme }) => ({
          '&.active': {
            background: theme.palette.secondary.light
          }
        })
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 0,
          '& .MuiTouchRipple-ripple .MuiTouchRipple-child': {
            borderRadius: 0
          },
          '&.active': {
            background: theme.palette.secondary.light
          }
        })
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&.Mui-disabled::selection': {
            WebkitTextFillColor: 'white'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // We override the body1 color above via allVariants.
          // This has a side effect on the input label color.
          // Therefore we need to reset the color here.
          color: defaultTheme.palette.text.secondary
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-disabled': {
            '.MuiSvgIcon-root ': {
              color: theme.palette.secondary.light
            }
          }
        })
      }
    },

    MuiChip: {
      styleOverrides: {
        label: ({ theme }) => ({
          fontWeight: theme.typography.h5.fontWeight,
          lineHeight: 'normal'
        })
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.main,
          svg: {
            color: 'inherit'
          }
        })
      }
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: 'none',
          fontSize: theme.typography.body1.fontSize
        })
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => ({
          fontWeight: `${theme.typography.h5.fontWeight}!important`,
          textTransForm: 'capitalize'
        })
      }
    }
  }
});

export const UXB_SPECIAL_COLORS = {
  ingredients: '#DBECEF',
  concepts: '#FFEAEA',
  pressRelease: '#F1EAF4',
  sampleCart: '#F1EAF4'
};
